import { takeLatest, put, call } from 'redux-saga/effects';
import { LOADER_CLOSE, LOADER_OPEN } from '../actions';
import scorm from '../../api/scorm';
import {
  SCORM_CATEGORIES_GET,
  SCORM_DETAILS_GET,
  SCORM_LIST_GET,
} from '../actions/scorm';
import { errorHandling } from '../../../utils/errors';

function* scormCategoriesGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      scorm.scormCategoriesGet
    );
    yield put({ type: SCORM_CATEGORIES_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > public > scormCategoriesGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* scormCategoriesGetWatch() {
  yield takeLatest(SCORM_CATEGORIES_GET._REQUEST, scormCategoriesGet);
}

function* scormListGet({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response, pager } = {} } = yield call(
      scorm.scormListGet,
      filters
    );
    yield put({ type: SCORM_LIST_GET._SUCCESS, response, pager });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > public > scormListGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* scormListGetWatch() {
  yield takeLatest(SCORM_LIST_GET._REQUEST, scormListGet);
}

function* scormDetailsGet({ id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      scorm.scormDetailsGet,
      id
    );
    yield put({ type: SCORM_DETAILS_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > public > scormDetailsGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* scormDetailsGetWatch() {
  yield takeLatest(SCORM_DETAILS_GET._REQUEST, scormDetailsGet);
}

export default [
  scormCategoriesGetWatch(),
  scormListGetWatch(),
  scormDetailsGetWatch(),
];
